import toUpper from "lodash/toUpper";
import { useEffect } from "react";
import { connect } from "react-redux";
import compOperations from "../comp/ducks/operations";
import listingOperations from "../listing/ducks/operations";
import { requestListingNonRequiredConstraints } from "../listing/ducks/validation";
import searchOperations from "../search/ducks/operations";
import { findAndValidateField } from "../utils/findAndValidateField";
import BrokerDashboard from "./BrokerDashboard";
import operations from "./ducks/operations";

const BrokerDashboardContainer = (props) => {
    const { resetDashboardParams, getBrokerDashboardData, userProfile } = props;

    const handleBlurValidate = (section, id, value) => {
        return findAndValidateField(requestListingNonRequiredConstraints, id, value);
    };

    useEffect(() => {
        resetDashboardParams();
        getBrokerDashboardData();
    }, [userProfile.user]);

    return <BrokerDashboard {...props} handleBlurValidate={handleBlurValidate} />;
};

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer,
        role: state.authReducer.userProfile.role,
        userProfile: state.authReducer.userProfile,
        brokerValues: state.dashboardReducer.brokerValues,
        requestModal: state.listingReducer.requestModal,
        modalData: state.compReducer.modalData,
        errors: state.utilsReducer.errors,
        searchResults: state.utilsReducer.searchResults,
        autocompleteResults: state.searchReducer.autocompleteResults,
        dashboardParams: state.dashboardReducer.dashboardParams,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBrokerDashboardData: () => {
            dispatch(operations.getBrokerDashboardData());
        },

        closeDeal: (listing) => {
            return dispatch(listingOperations.closeDeal(listing));
        },
        toggleRequestModal: (spaceType, transactionType) => {
            dispatch(listingOperations.toggleRequestModal(spaceType, transactionType));
        },
        searchProperty: (term) => {
            dispatch(searchOperations.searchPropertyAutocomplete(term));
        },
        handleCompInput: (path, value) => {
            dispatch(compOperations.handleCompInput(path, value));
        },
        selectProperty: (property) => {
            dispatch(compOperations.selectPropertyFromAutocomplete(property));
        },
        handleDashboardInput: (e) => {
            dispatch(operations.handleDashboardInput(e.target.id, e.target.value));
        },
        resetDashboardParams: () => {
            dispatch(operations.resetDashboardParams());
        },
        updateSearchTerm: (value, searchType) => {
            dispatch(searchOperations.updateFilter("searchTerm", value, searchType));
        },
        handleSearchSubmit: () => {
            dispatch(searchOperations.executeSearch("property_modal"));
            dispatch(searchOperations.storeSearchRun(true, toUpper("property_modal")));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrokerDashboardContainer);
